module.exports = __webpack_public_path__ + "media/images/category-climate-7e27eb458001a4c8cf9a4fb6dad361fc.jpg";